/**
 * Created by M on 2017/6/20.
 */
const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
const dateFormat = 'YYYY-MM-DD';

function fomratDate(dateTime) {
  if (!dateTime) {
    return '';
  }
  return moment(dateTime).format(dateFormat)
}

function fomratDateTime(dateTime) {
  if (!dateTime) {
    return '';
  }
  return moment(dateTime).format(dateTimeFormat)
}


export {fomratDate,fomratDateTime}



// WEBPACK FOOTER //
// ./src/config/format/dateFormat.js